import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { theme } from "ui-components";

export const DomusoIcon = (props: any) => (
  <Svg
    width={props.width}
    height={props.height}
    viewBox="0 0 22 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.411 1.293v1.183h2.492V.11h-2.492v1.184zM15.326 2.32l.035 1.215H17.854l.035-1.215.036-1.215H15.29l.036 1.215zm2.84 3.395v1.496h2.99V4.22h-2.991v1.495zm-3.334-.781l-1.9.04V13.54l-.847-.345C5.318 10.441-1.742 16.967.521 23.884c2.628 8.033 13.963 8.008 16.569-.037.41-1.267.46-2.475.373-9.128l-.085-6.51h-.957V5.966H17.432l-.038-.53c-.045-.615.231-.56-2.562-.501zm4.08 4.146v.748h1.62V8.333h-1.62v.748zm-8.3 8.399c2.27 1.11 3.055 4.415 1.476 6.212-.32.363-.46.269-1.705-1.153-1.654-1.889-1.592-1.894-3.422.286-1.215 1.448-1.67 1.341-2.21-.519-.975-3.352 2.696-6.375 5.861-4.826z"
      fill={props.color || theme.colors.primary}
      stroke={props.stroke}
      strokeWidth={props.strokeWidth}
    />
  </Svg>
);
